import { Injectable } from '@angular/core';
import { mapFetchResultData } from '@x/common/graph';
import { Observable } from 'rxjs';
import { ShopChannelAdsGQL } from './gql/shop-ad.gql.generated';
import { TShopAd, TShopChannelAdsQuery } from './types/shop-ad';

@Injectable()
export class ShopAdService {
  constructor(private readonly shopChannelAdsGQL: ShopChannelAdsGQL) {}

  fetchShopChannelAds$(query: TShopChannelAdsQuery): Observable<TShopAd[]> {
    return this.shopChannelAdsGQL.fetch(query).pipe(mapFetchResultData((r) => r.shopAds));
  }
}
